import {getIndustryName, getScaleName, getStageName} from "@/utils/job";
import {
    STATUS_APPROVED,
    STATUS_APPROVED_WITH_APPLYING,
    STATUS_APPROVED_WITH_REJECTED,
} from "@/constants/audit";
import {getCompanyStatusName} from "@/utils/company";

export default class CompanySsr {

    constructor(options) {
        this._id = options?._id || 0
        this.fullName = options?.fullName || ""
        this.nickName = options?.nickName || ""
        this.logoKey = options?.logoKey || ""
        this.logoUrl = options?.logoUrl || ""
        this.industryId = options?.industryId || 0
        this.industryId2 = options?.industryId2 || 0
        this.industryId3 = options?.industryId3 || 0
        this.scaleId = options?.scaleId || 0
        this.stageId = options?.stageId || 0
        this.webSiteUrl = options?.webSiteUrl || ""
        this.statusId = options?.statusId || 0
        this.statusText = options?.statusText || "-"
        this.auditExtra = options?.auditExtra || "{}"

        this.isNew = this._id <= 0
        this.industryName = getIndustryName(this.industryId)
        this.industryName2 = getIndustryName(this.industryId2)
        this.industryName3 = getIndustryName(this.industryId3)
        this.scaleName = getScaleName(this.scaleId)
        this.stageName = getStageName(this.stageId)
        //this.statusShort = companyStatusShort(this.statusId)
        this.statusShort = getCompanyStatusName(this.statusId)
        this.isApproved = this.statusId == STATUS_APPROVED
            || this.statusId == STATUS_APPROVED_WITH_APPLYING
            || this.statusId == STATUS_APPROVED_WITH_REJECTED

        this.industryNames = [this.industryName,
            this.industryName2,
            this.industryName3]
            .filter(function (s) {
                return s && s.trim()
            }).join(",")
    }

    toJSON () {
        return { ...this }
    }
}
